import { ChevronLeft } from "@cynthai/icons";
import { Button } from "@cynthai/ui";
import { useCanGoBack, useRouter } from "@tanstack/react-router";

import { m } from "@/paraglide/messages";

function PageHeader({
  title,
  children,
  backButton,
  onBackClick,
}: Readonly<{
  title: string;
  children?: React.ReactNode | React.ReactNode[];
  backButton?: boolean;
  onBackClick?: () => void;
}>) {
  const router = useRouter();
  const canGoBack = useCanGoBack();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      router.history.back();
    }
  };

  return (
    <div
      className={`bg-background-2 flex h-16 items-center justify-between px-16`}
    >
      {backButton && canGoBack && (
        <Button
          size="square"
          aria-label={m.go_back()}
          onClick={handleBackClick}
        >
          <ChevronLeft />
        </Button>
      )}
      <h1 className="text-text-primary mr-auto font-medium">{title}</h1>

      {children}
    </div>
  );
}

export default PageHeader;
